import { animate, state, style, transition, trigger } from '@angular/animations';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { isString, pick } from 'lodash-es';

@Component({
  selector: 'shared-error-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ClipboardModule,
  ],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ErrorDialogComponent implements OnInit {
  data = inject<{
    message: string;
    error?: string | Error;
    data?: unknown;
}>(MAT_DIALOG_DATA);
  private auth = inject(Auth);

  public showDetails = false;
  public formattedData = '';
  public errorMessage?: string;
  public now = new Date();

  constructor() {
    const data = this.data;

    if (data.error instanceof Error) {
      this.errorMessage = data.error.message;
    } else if (isString(data.error)) {
      this.errorMessage = data.error;
    }
  }

  ngOnInit() {
    const stack = this.data.error instanceof Error ? this.data.error.stack : undefined;

    this.formattedData = JSON.stringify({
      error: {
        title: this.data.message,
        message: this.errorMessage,
        stack,
        date: this.now.toISOString(),
      },
      // application: {
      //   name: applicationInfo.name,
      //   version: applicationInfo.version,
      //   url: this.$window.instance.location.href,
      // },
      user: pick(this.auth.currentUser, ['uid']),
      data: this.data.data,
    }, null, 2);
  }

}
